import { render } from "./ViewCash.vue?vue&type=template&id=b2b8ac46&ts=true"
import script from "./ViewCash.vue?vue&type=script&lang=ts"
export * from "./ViewCash.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__